/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component} from 'react';
import AccountService from '../../services/account.service';
import AlertService from '../../services/alerts.service';
import CommentsService from '../../services/comments.service';
import 'react-tabs/style/react-tabs.css';
import memoize from 'memoize-one';
import moment from 'moment';
import {Event, PageView, Timing} from "../GoogleAnalytics";

//import { jsAsset, alertCustomer, jsAlert, jsGraph, jsOpportunity, jsUpdateOpportunity, jsGraphData } from "../../componentObjects";
import TriageAlertsTable from '../TriageAlerts/TriageAlertsTable';
import {jsAccount} from '../../componentObjects';
import alerttypemessagingService from "../../services/alerttypemessaging.service";
import { consolidateAlerts } from "../../utils/alertUtils";

class CustomerAlerts extends Component {
    static displayName = CustomerAlerts.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.getAlerts = this.getAlerts.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        this.reloadTable = this.reloadTable.bind(this);
        this.filterAlerts = this.filterAlerts.bind(this);
        this.consolidateAlerts = this.consolidateAlerts.bind(this);
        this.addConversationToAlert = this.addConversationToAlert.bind(this);
        this.updateAlertList = this.updateAlertList.bind(this);
        this.getAccount = this.getAccount.bind(this);

        this.state = {
            alertArgs: {
                queryId: "custom",
                startTime: null,
                endTime: null,
                isActive: true,
                priority: 3
            },
            alertType: "Active",
            alertList: [],
            currentAccount: jsAccount,
            loading: true,
            alertTableLoading: false,
            alertMessaging: [],
            assetComments: [],
            orgId: this.props.currentCustomerId,
            partnerInfo: {},
            tableObj: {},
            startTabIndex: 0,
            consolidateAlertsDict: {}
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        PageView();
        this.getAccount(this.props.currentCustomerId);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId) {
            this.setState({ loading : true }, () => {
                this.getAccount(this.props.currentCustomerId);
            });
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    memAlerts = memoize(this.getAlerts);

    async getAlerts(id, start = null, end = null) {
        let startTime = performance.now();
        let now = (end == null ? moment() : end);
        let before = (start == null ? moment(now).add(-5, 'years') : start);
        let nowStr = now.format();
        let beforeStr = before.format();
        let nowDT = new Date(nowStr);
        let beforeDT = new Date(beforeStr);
        let startTabIndex = 0;
        let alertList = [];
        let ignoreIsClosed = true;

        this.setState(prevState => ({
            alertTableLoading: true,
            orgId: this.props.currentCustomerId,
            alertArgs: {
                ...prevState.alertArgs,
                startTime: beforeStr,
                endTime: nowStr
            }
        }), async () => {
            await alerttypemessagingService.getpartnermessaging(this.props.currentPartnerId)
                .then(response3 => {
                    if (this._isMounted)
                        this.setState({ alertMessaging: response3 }, async () => {
                            await CommentsService.getassetcomments()
                            .then(response6 => {
                                this.setState({ assetComments: response6.data }, async () => {
                                    let request = {
                                        startTime: beforeDT,
                                        endTime: nowDT,
                                        organizationId: this.props.currentCustomerId,
                                        partnerOrganizationId: this.props.currentPartnerId,
                                        ignoreIsClosed: ignoreIsClosed
                                    }
                                    await AlertService.gethistoricalalertslist(request)
                                        .then(response5 => {
                                            this.setState({ tableObj: response5.data }, () => {

                                                let filteredEquipAlertList = this.state.tableObj.equipmentAlertsList !== undefined && this.state.tableObj.equipmentAlertsList !== null ? this.state.tableObj.equipmentAlertsList : [];


                                                if (filteredEquipAlertList.length > 0) {
                                                    alertList = filteredEquipAlertList;
                                                    startTabIndex = 0;
                                                }
                                                else {

                                                    alertList = this.state.tableObj.deviceAlertsList !== null ? this.state.tableObj.deviceAlertsList : [];
                                                    startTabIndex = 1;
                                                }
                                                this.setState({ loading: false, alertTableLoading: false, /* alertList: alertList,*/ startTabIndex: startTabIndex }, () => {
                                                    this.consolidateAlerts(alertList);
                                                });
                                            });
                                        })
                                })
                            })
                        });
                })
                .catch(e => {
                    console.log(e);
                });
        });

    }

    async getAccount(id) {
        var startTime = performance.now();
        await AccountService.get(id)
            .then(async response => {
                if (this._isMounted) {
                    let account = response.data;

                    // If AccountService returned no useful data (new infra non-integer proCompanyId),
                    // fall back to AlertService.get() which fetches from the RIS backend.
                    if (!account || !account.accountId) {
                        try {
                            const alertResp = await AlertService.get(id);
                            if (alertResp?.data) {
                                account = {
                                    ...account,
                                    accountId: alertResp.data.organizationId || id,
                                    firstName: alertResp.data.firstName || "",
                                    lastName: alertResp.data.lastName || "",
                                    name: alertResp.data.fullName || alertResp.data.name || `${alertResp.data.firstName || ""} ${alertResp.data.lastName || ""}`.trim(),
                                    email: alertResp.data.email || "",
                                    phone: alertResp.data.phone || "",
                                    address: alertResp.data.address || "",
                                    city: alertResp.data.city || "",
                                    state: alertResp.data.state || "",
                                    zip: alertResp.data.zip || ""
                                };
                            }
                        } catch (e) {
                            console.log("Fallback to AlertService.get failed:", e);
                        }
                    }

                    this.setState({
                        currentAccount: account,
                        loading: false,
                        alertTableLoading: true
                    }, async () => {
                        this.getAlerts();
                        var elapsedTime = performance.now() - startTime;
                        Timing("Account Loading", "loading", elapsedTime, "Customer Account Loading");
                    });
                }
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    loading: false
                });
            });
    }

    consolidateAlerts(alerts) {
        const isDeviceHealthAlerts = this.state.startTabIndex === 1;
        const { distinctAlerts, consolidatedAlertsDict } = consolidateAlerts(alerts, isDeviceHealthAlerts);

        if (this._isMounted) {
            this.setState({ alertList: distinctAlerts, consolidateAlertsDict: consolidatedAlertsDict, loading: false, alertTableLoading: false });
        }
    }
    
    async filterAlerts(tabIndex, radio, isActive, isScheduled, selectedTypes) {
        if (this.state.tableObj.equipmentAlertsList !== null && this.state.tableObj.equipmentAlertsList !== undefined)
            this.setState({ alertTableLoading: true }, () => {
                let alerts = tabIndex == 0 ? this.state.tableObj.equipmentAlertsList : this.state.tableObj.deviceAlertsList;

                if (radio === "Critical")
                    alerts = alerts.filter(a => a.severity === "Critical");
                else if (radio === "Warning")
                    alerts = alerts.filter(a => a.severity === "Warning");

                if (isActive !== null) {
                    if (isActive == true)
                        alerts = alerts.filter(a => a.alert.isActive == true);
                    else
                        alerts = alerts.filter(a => a.alert.isActive == false);
                }

                if (isScheduled !== null) {
                    if (isScheduled == true)
                        alerts = alerts.filter(a => a.alert.isMuted == true);
                    else
                        alerts = alerts.filter(a => a.alert.isMuted == false);
                }

                this.consolidateAlerts(alerts); //this.setState({ alertList: alerts, alertTableLoading: false });  
            });
    }

    async reloadTable() {
        this.setState({
            alertTableLoading: true,
            alertList: []
        });

        this.setState(prevState => ({
            alertArgs: {
                ...prevState.alertArgs,
                isActive: this.state.alertType === "Inactive" ? false : true
            }
        }));

        await this.getAlerts();
    }

    async changeRadio(val) {
        let x = val;
        Event("Customer Alerts Radio Clicked", "User clicked one of the radio buttons for the alert table in Customer Alerts", "Customer Alerts Radio Clicked");

        this.setState({
            alertType: x,
            alertList: []
        });

        this.setState(prevState => ({
            alertArgs: {
                ...prevState.alertArgs,
                isActive: x === "Inactive" ? false : true
            }
        }));

        this.setState({ alertTableLoading: true }, async () => {
            await this.getAlerts();
        });
    }

    addConversationToAlert(conversationId, alertId) {
        var index = 0;
        var alert = null;

        index = this.state.tableObj.alerts.findIndex(a => {
            return a.alertId === alertId;
        });

        var tempTableObj = [...this.state.tableObj.alerts];
        alert = { ...tempTableObj[index] };
        alert.conversationId = conversationId.toString();
        tempTableObj[index] = alert;

        this.setState(prevState => ({
            tableObj: {
                ...prevState.tableObj,
                alerts: tempTableObj
            }
        }));
    }

    updateAlertList(alertsTable) {
        this.setState({ alertList: alertsTable });
    }

    render() {
        const { classes } = this.props;
        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: '-225px !important',
                },
            })}>
                <div className={this.props.isModal ? "infoPage margin-left-0" : "infoPage"}>
                    <h2 className="pageTitle dashboard-title" id="tabelLabel">
                        Alert History for {this.state.currentAccount.name}
                    </h2>

                    <TriageAlertsTable alertList={this.state.alertList} startTabIndex={this.state.startTabIndex} _isMounted={this._isMounted} loading={this.state.loading} alertTableLoading={this.state.alertTableLoading} alertMessaging={this.state.alertMessaging} assetComments={this.state.assetComments}  tableObj={this.state.tableObj}
                        filterAlerts={this.filterAlerts} reloadTable={this.reloadTable} customers={this.props.customers} consolidateAlertsDict={this.state.consolidateAlertsDict} addConversationToAlert={this.addConversationToAlert} userOrg={this.props.userOrg} updateAlertList={this.updateAlertList}
                        setActivePath={this.props.setActivePath} source="CustomerAlerts" updateSearch={this.getAlerts} isModal={this.props.isModal} customerId ={this.props.currentCustomerId}/>


                </div>
            </div>
        );
    }
}

export default CustomerAlerts;